module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Light.ca930ad.woff2";